import styled from 'styled-components';

export const PdfInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PdfInput = styled.input`
  display: none;
`;

export const ErrorText = styled.span`
  color: ${({ theme }) => theme.colors.red};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`; 